import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ILeagueParticipant } from "redux/reducers/models/league";

//GET Players
//Retrieve a list of players in a specific league
export async function GetParticipant(
  params: { id?: string | number; league_id?: string | number; league_division_id?: string | number; limit?: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<ILeagueParticipant[]>(
    APIUrl(AdminType.FacilityAdmin, "/league/participant"),
    params,
    useGlobalLoader,
    token,
  );
}

//POST New Player
//Add new player to leage
export async function PostParticipant(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/league/participant"), params, useGlobalLoader);
}

// Update Player
//Update player within a league
export async function PutParticipant(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/league/participant"), params, useGlobalLoader);
}

type DeleteLeagueParticipantType = {
  participant_id?: number;
  participant_ids?: number[];
};
// Delete Player
//Delete player within a league
export async function DeleteLeagueParticipant(params: DeleteLeagueParticipantType, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/league/participant"), params, useGlobalLoader);
}

export async function PutExportParticipants(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/league/participant/export"), params, useGlobalLoader);
}

//Import League Players
export async function ImportLeaguePlayers(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/league/participant/import"), params, useGlobalLoader);
}

export async function CopyLeagueParticipants(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/league/participant/copy"), params, useGlobalLoader);
}

type GetLeagueRosterType = {
  league_id: number;
};

export async function GetLeagueRosterTemplate(params: GetLeagueRosterType, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/league/participant/template"), params, useGlobalLoader);
}
